import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { DASHBOARD_URL } from "@constants/routes";
import { ModalSizeTypes } from "@enums/modal-size-types";
import { DefaultModal } from "../../modals/default-modal/default-modal";
import styles from "./error-boundary-modal.less";

type ErrorBoundaryModalProps = {
    errorId: string;
    clearError: () => void;
};

export const ErrorBoundaryModal = (props: ErrorBoundaryModalProps) => {
    const { errorId, clearError } = props;

    const handleRefreshPageClick = () => {
        clearError();
    };

    const handleNavigateToDashboardClick = () => {
        window.location.replace(DASHBOARD_URL);
    };

    return (
        <DefaultModal
            automationId="error-boundary-modal"
            ariaLabelledBy="error-boundary-modal-title"
            onHide={handleRefreshPageClick}
            backdrop={"static"}
            keyboard={false}
            isMaxWidth={false}
            size={ModalSizeTypes.MEDIUM}
        >
            <Modal.Header id={"error-boundary-modal-title"} closeButton>
                <Modal.Title>Oops, an error has occurred</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>
                    The application has received an unrecoverable error.
                    Refresh the page to continue.
                    If the error persists, please contact our support team.
                </div>
                {errorId && (
                    <div className={styles.errorIdContainer}>
                        <span>Error ID: {errorId}</span>
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer>
                {window.location.pathname !== DASHBOARD_URL && (
                    <Button variant={"outline-secondary"} onClick={handleNavigateToDashboardClick}>Go to Dashboard</Button>
                )}
                <Button onClick={handleRefreshPageClick}>Reload Current Page</Button>
            </Modal.Footer>
        </DefaultModal>
    );
};